import { ConfigurationVariables } from "./config";

export const OidcConfig = {
    client_id: ConfigurationVariables.FORGE_IAM_CLIENT_ID,
    redirect_uri: ConfigurationVariables.FORGE_IAM_REDIRECT_URI + "/callback",
    scope: ConfigurationVariables.FORGE_IAM_SCOPE,
    authority: ConfigurationVariables.FORGE_IAM_AUTHORITY,
  };
  